module.exports = __webpack_public_path__ + "static/img/video.66eff02a.png";